<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Edit User</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
  </div>
  <div class="ttmodal__body" [class.hidden]="loadingCurrentDetails">
    <div class="input-container">
      <span class="label">Username (Login)<span class="red-text">*</span></span>
      <span class="input-icon input-icon--mat">
        <i class="material-icons">assignment_ind</i>
      </span>
      <input [(ngModel)]="username" type="text" placeholder="Bobsmith1" required>
    </div>
    <div class="input-container">
      <span class="label">Email <span class="red-text">*</span></span>
      <span class="input-icon input-icon--mat">
        <i class="material-icons">mail_outline</i>
      </span>
      <input [(ngModel)]="email" type="text" placeholder="example@email.com" required>
    </div>
    <div class="input-container">
      <span class="label">Full Name <span class="red-text">*</span></span>
      <span class="input-icon input-icon--mat">
        <i class="material-icons">person_outline</i>
      </span>
      <input [(ngModel)]="name" type="text" placeholder="Bob Smith" (blur)="setInitialsFromName()" required>
    </div>
    <div class="input-container">
      <span class="label">User Initials</span>
      <span class="input-icon input-icon--mat">
        <i class="material-icons">person_outline</i>
      </span>
      <input [(ngModel)]="userInitals" type="text" placeholder="BS" maxlength="2">
    </div>
    <div class="input-container" *ngIf="password.length > 0">
      <span class="label">Password</span>
      <span class="input-icon input-icon--mat">
        <i class="material-icons">lock_outline</i>
      </span>
      <input disabled="true" [(ngModel)]="password" type="text">
    </div>

    <div class="input-container">
      <span class="label">Phone No</span>
      <span class="input-icon input-icon--mat">
        <i class="material-icons">phone</i>
      </span>
      <input [(ngModel)]="phone" type="text" placeholder="123456789" (keypress)="Validate($event)">
    </div>

    <div class="input-container">
      <span class="label">USI </span>
      <span class="input-icon input-icon--mat">
        <i class="material-icons">admin_panel_settings</i>
      </span>
      <input [(ngModel)]="USI" type="text" placeholder="12345678" maxlength="10">
    </div>
    <div class="input-container">
      <span class="label">Language <span class="red-text">*</span></span>
      <span class="input-icon input-icon--mat">
        <i class="material-icons">language </i>
      </span>
      <select [(ngModel)]="selectedLanguageId" class="get-select-text">
        <option value="" disabled selected>Select Language</option>
        <option *ngFor="let language of languagesList" [value]="language.Id">{{language.Name}}</option>
      </select>
    </div>
    <div class="input-container" *ngIf="showLoginMethod">
      <span class="label">Sign In Method</span>
      <span class="input-icon input-icon--mat">
        <mat-icon>vpn_key</mat-icon>
      </span>
      <mat-radio-group [(ngModel)]="loginMethod"
                       class="get-select-text"
                       style="padding: 5px 5px; display: flex; gap: 20px;">

        <mat-radio-button value="Default">
          <span class="radio-content">
            <mat-icon>person</mat-icon>
            <span>Default</span>
          </span>
        </mat-radio-button>

        <mat-radio-button value="MFA">
          <span class="radio-content">
            <mat-icon>verified_user</mat-icon>
            <span>Multi-Factor Authentication (MFA)</span>
          </span>
        </mat-radio-button>

        <mat-radio-button value="SSO" *ngIf="SSOEnabled">
          <span class="radio-content">
            <mat-icon>key</mat-icon>
            <span>Single Sign-On (SSO)</span>
          </span>
        </mat-radio-button>

      </mat-radio-group>
    </div>
    <span class="input-description">What level of access, and to who will this user have access? </span>
    <span class="input-description" style="font-weight: bold;">Mobile Application </span>
    <div class="input-container" *ngIf="allowCheckUndercarriageAccess && allowCheckGetAccess">
      <mat-checkbox class="checkbox-margin" [(ngModel)]="undercarriageEnabled">Undercarriage</mat-checkbox>
      <mat-checkbox class="checkbox-margin" [(ngModel)]="getEnabled">GET/Digital Inspection</mat-checkbox>
      <mat-checkbox [(ngModel)]="safetyEnabled">Safety</mat-checkbox>
    </div>
    <div class="input-container" *ngIf="showAlertFiled">
      <span class="label">Alerts Enable <span class="red-text">*</span></span>
      <select class="select" [(ngModel)]="ShowAlertTab">
        <option value="0">{{'Yes' | translate | async}}</option>
        <option value="1">{{'No' | translate | async}}</option>
      </select>
    </div>
    <span class="input-description">Which job roles should this user have? </span>
    <span class="input-description" style="font-weight: bold;">Main Application </span>
    <div class="input-container">
      <span class="label">Job Roles <span class="red-text">*</span></span>
      <mat-form-field style="width:45%">

        <mat-select [(ngModel)]="jobRoleSelectedItems" multiple>
          <mat-option *ngFor="let role of jobRoleDropdownList" [value]="role.id">{{ role.itemName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- <div class="input-container">
        <span class="label">Job Roles <span class="red-text">*</span></span>
        <angular2-multiselect [data]="jobRoleDropdownList" [(ngModel)]="jobRoleSelectedItems" [settings]="jobRoleDropdownSettings" style="border: 1px solid transparent;
        border-radius: 0;
        outline: 0;
        width: auto;
        height: unset;
        font-size: 14px;
        margin: 0;
        box-sizing: border-box;
        transition: all .3s;
        flex-grow: 1;"></angular2-multiselect>
    </div> -->
  </div>
  <mat-spinner class="align-center" *ngIf="loadingCurrentDetails"></mat-spinner>
  <div class="ttmodal__footer" [class.hidden]="loadingCurrentDetails">
    <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
    <a class="button button--primary" (click)="updateUser()" [class.loading]="savingNewUser"><span class="button__text">Update User</span></a>
  </div>
</div>
